import { render, staticRenderFns } from "./popupWindow.vue?vue&type=template&id=1ab11aeb&"
import script from "./popupWindow.vue?vue&type=script&lang=js&"
export * from "./popupWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports